import { useQuery } from '@tanstack/react-query';
import { API } from 'api';
import { persistedQueryClient } from 'components/CacheableQueryClientProvider';
import { User } from 'shared/types';

const getAuthUser = async (): Promise<User> => {
  const response = await API.get<User>('/auth/user/');
  return response.data;
};

export const useAuthUserQuery = (enabled: boolean): User | null => {
  const { data } = useQuery(
    {
      queryKey: ['auth-user'],
      queryFn: getAuthUser,
      staleTime: 1000 * 60 * 60 * 48, // 48 hours
      gcTime: 1000 * 60 * 60 * 49, // 49 hours - must be bigger than staleTime
      enabled,
    },
    persistedQueryClient,
  );

  const authUser = data || null;

  return authUser;
};
